import { DEFAULT_HOUSE_RULES } from '../types/house-rules.js';
const ROOM_SETTING_KEYS = new Set(['turnTimeLimit', 'targetScore', 'houseRules', 'allowSpectators', 'spectatorMode']);
const HOUSE_RULE_KEYS = new Set(Object.keys(DEFAULT_HOUSE_RULES));
const TURN_TIME_LIMITS = new Set([15, 30, 60]);
const TARGET_SCORES = new Set([200, 300, 500, 1000]);
const HAND_LIMITS = new Set([null, 15, 20, 25]);
const HAND_REVEAL_THRESHOLDS = new Set([null, 2, 3]);
const UNO_PENALTY_COUNTS = new Set([2, 4, 6]);
const BLITZ_TIME_LIMITS = new Set([null, 120, 300, 600]);
function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function isCurrentHouseRuleValue(key, value) {
    switch (key) {
        case 'handLimit':
            return HAND_LIMITS.has(value);
        case 'handRevealThreshold':
            return HAND_REVEAL_THRESHOLDS.has(value);
        case 'unoPenaltyCount':
            return UNO_PENALTY_COUNTS.has(value);
        case 'blitzTimeLimit':
            return BLITZ_TIME_LIMITS.has(value);
        default:
            return typeof value === 'boolean';
    }
}
export function isCurrentHouseRulesPatch(value) {
    if (!isRecord(value))
        return false;
    return Object.entries(value).every(([key, ruleValue]) => HOUSE_RULE_KEYS.has(key) && isCurrentHouseRuleValue(key, ruleValue));
}
export function isCurrentHouseRules(value) {
    if (!isCurrentHouseRulesPatch(value))
        return false;
    return (HOUSE_RULE_KEYS.size === Object.keys(value).length && [...HOUSE_RULE_KEYS].every(key => Object.hasOwn(value, key)));
}
export function isCurrentRoomSettingsPatch(value) {
    if (!isRecord(value) || Object.keys(value).some(key => !ROOM_SETTING_KEYS.has(key))) {
        return false;
    }
    return ((!Object.hasOwn(value, 'turnTimeLimit') ||
        (typeof value['turnTimeLimit'] === 'number' && TURN_TIME_LIMITS.has(value['turnTimeLimit']))) &&
        (!Object.hasOwn(value, 'targetScore') ||
            (typeof value['targetScore'] === 'number' && TARGET_SCORES.has(value['targetScore']))) &&
        (!Object.hasOwn(value, 'allowSpectators') || typeof value['allowSpectators'] === 'boolean') &&
        (!Object.hasOwn(value, 'spectatorMode') ||
            value['spectatorMode'] === 'full' ||
            value['spectatorMode'] === 'hidden') &&
        (!Object.hasOwn(value, 'houseRules') || isCurrentHouseRulesPatch(value['houseRules'])));
}
export function isCurrentRoomSettings(value) {
    if (!isCurrentRoomSettingsPatch(value) || !isRecord(value))
        return false;
    return (ROOM_SETTING_KEYS.size === Object.keys(value).length &&
        [...ROOM_SETTING_KEYS].every(key => Object.hasOwn(value, key)) &&
        isCurrentHouseRules(value['houseRules']));
}
export function applyRoomSettingsPatch(current, patch) {
    return {
        ...current,
        ...patch,
        houseRules: {
            ...current.houseRules,
            ...patch.houseRules,
        },
    };
}
//# sourceMappingURL=room-settings-validation.js.map